export default "__VITE_ASSET__b23eb100__"